// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".contentIconBack{background-color:#00ffdc;border-radius:25px;height:35px!important;width:35px!important;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.ComissionsContainer__display--elipse{.contentIconBack{border-radius:40px;width:71px!important;height:71px!important}}", ""]);
// Exports
module.exports = exports;
